module.exports = __webpack_public_path__ + "img/doc.5008a61f.svg";